import { Title } from '@nimbus-ds/components';
import { ConceptCode } from '@tiendanube/common';
import { useGetIsFreePlan } from 'domains/Auth/hooks';
import { PlanDowngradeAlert } from 'domains/Billing/BillingPlans/pages/BillingPlansPage/components';
import { PaymentStatusAlert } from 'domains/Billing/Checkout/components';
import { useAppName } from 'domains/Billing/Checkout/hooks';
import { CancelRecurrentPaymentButton } from 'domains/Billing/Checkout/pages/components';
import { trackingBillingRecurringCancel } from 'domains/Billing/Checkout/tracking';
import useTranslationBilling from 'domains/Billing/useTranslationBilling';
import {
  SubscriptionDetail,
  ProportionalChargeAlert,
  TrialStatusAlert,
  PaymentHistory,
  ExtraFeeDetail,
  OfflineExtraDetail,
  NuvemchatExtraDetail,
} from './components';

interface ConceptDetailContentProps {
  concept: ConceptCode;
  externalReference?: string;
  chargeId?: string;
}

function ConceptDetailContent({
  concept,
  externalReference,
  chargeId,
}: ConceptDetailContentProps) {
  const t = useTranslationBilling('checkout.conceptDetailContent');
  const isPlan = concept === 'plan-cost';
  const { isTrial } = useGetIsFreePlan();
  const { appName } = useAppName(concept, externalReference);

  const trackRecurrentPaymentCancelation = () => {
    trackingBillingRecurringCancel();
  };

  const isAppExtraFee = concept === 'app-extra-fee';
  const title = isAppExtraFee ? appName : t(`${concept}.title`);
  const isOfflineExtraPointCost = concept === 'offline-pos-extra-location';
  const isNuvemchatCost = concept === 'app-nuvemchat-cost';

  return (
    <>
      {!!title && <Title>{title}</Title>}
      {!!chargeId && <ProportionalChargeAlert chargeId={chargeId} />}
      {!!isPlan && !!isTrial && <TrialStatusAlert />}
      {concept === 'plan-cost' && <PlanDowngradeAlert />}
      <PaymentStatusAlert
        concept={concept}
        externalReference={externalReference}
        chargeId={chargeId}
        showPaymentButton
      />
      {isAppExtraFee && !!chargeId && <ExtraFeeDetail chargeId={chargeId} />}
      {isOfflineExtraPointCost && !!chargeId && (
        <OfflineExtraDetail chargeId={chargeId} />
      )}
      {isNuvemchatCost && !!chargeId && <NuvemchatExtraDetail />}
      <SubscriptionDetail
        concept={concept}
        externalReference={externalReference}
      />
      <CancelRecurrentPaymentButton
        conceptCode={concept}
        externalReference={externalReference}
        trackEvent={trackRecurrentPaymentCancelation}
      />
      <PaymentHistory concept={concept} appId={externalReference} />
    </>
  );
}

export default ConceptDetailContent;
